<div class="chatbot-dialog-container">
  <button
    class="sidebar-resize-handle"
    type="button"
    aria-label="Resize Copilot sidebar"
    (pointerdown)="onSidebarResizeStart($event)"
    (keydown)="onSidebarResizeKeydown($event)">
  </button>
  @if (!isConfigured) {
    <div class="api-key-config">
      <h3>DOTS Copilot</h3>
      <p class="api-key-description">
        DOTS Copilot is not configured. Please contact your administrator to set up at least one AI provider (OpenAI, Anthropic, Gemini, or Ollama) in System Settings.
      </p>
      <div class="api-key-actions">
        <button
          mat-stroked-button
          (click)="onClose()"
          type="button">
          Close
        </button>
      </div>
    </div>
  } @else if (!consentGiven) {
    <div class="consent-banner">
      <div class="consent-icon">
        <img src="assets/device-illustrations/flask.svg" alt="DOTS Copilot" class="flask-icon" />
      </div>
      <h3>DOTS Copilot - Prototype Disclaimer</h3>
      <p>DOTS Copilot is an experimental AI assistant. Responses may be inaccurate, incomplete, or misleading - always review outputs carefully before acting on them.</p>
      <p>By using this prototype, you agree that your inputs and conversation data may be shared with Scientific Bioprocessing Inc. (SBI) and aquila biolabs GmbH for evaluation and improvement purposes.</p>
      <div class="consent-actions">
        <button
          mat-stroked-button
          (click)="onClose()"
          type="button">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          (click)="onAcceptConsent()"
          type="button">
          I Understand
        </button>
      </div>
    </div>
  } @else if (isWorkflowModeActive()) {
    <div class="chat-layout">
      <div class="chat-container">
        <div class="chat-header">
          <span class="workflow-badge">Agent Workflow</span>
          @if (currentConversationScope) {
            <span class="workflow-badge">{{ currentConversationScope.contextLabel }}</span>
          }
          <button
            mat-icon-button
            (click)="onClose()"
            matTooltip="Close Copilot"
            type="button"
            class="close-sidebar-button">
            <ion-icon name="close-outline"></ion-icon>
          </button>
        </div>
        @if (chatkitError) {
          <div class="error-message">
            <mat-icon>error_outline</mat-icon>
            <span class="error-text">{{ chatkitError }}</span>
          </div>
        }
        <div class="chatkit-wrapper">
          <openai-chatkit
            #chatkitElement
            class="chatkit-embed">
          </openai-chatkit>
        </div>
      </div>
    </div>
  } @else {
    <div class="chat-layout">
      <!-- Sidebar overlay -->
      @if (showSidebar) {
        <div class="sidebar-backdrop" (click)="toggleSidebar()"></div>
        <div class="sidebar">
          <div class="sidebar-header">
            <button
              mat-flat-button
              color="primary"
              class="new-chat-button"
              (click)="onNewConversation()"
              type="button">
              <ion-icon name="add-outline"></ion-icon>
              <span>New Chat</span>
            </button>
          </div>

          <div class="conversations-list">
            @if (isLoadingConversations) {
              <div class="loading-conversations">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
            } @else if (conversations.length === 0) {
              <div class="no-conversations">
                <p>No conversations yet</p>
              </div>
            } @else {
              @for (conversation of conversations; track conversation.id) {
                <div
                  class="conversation-item"
                  [class.active]="currentConversationId === conversation.id"
                  (click)="onSelectConversation(conversation)">
                  @if (editingConversationId === conversation.id) {
                    <input
                      type="text"
                      class="rename-input"
                      [(ngModel)]="editingTitle"
                      (click)="$event.stopPropagation()"
                      (keydown)="onRenameKeydown($event, conversation)"
                      (blur)="onSaveRename(conversation)"
                      autofocus />
                  } @else {
                    <div class="conversation-info">
                      <span class="conversation-title">{{ conversation.title }}</span>
                      @if (conversation.contextLabel) {
                        <span class="conversation-scope">{{ conversation.contextLabel }}</span>
                      }
                      <span class="conversation-date">{{ formatConversationDate(conversation.updatedAt) }}</span>
                    </div>
                    <div class="conversation-actions">
                      @if (isScopedConversation(conversation)) {
                        <span class="shared-conversation-badge">Shared</span>
                      }
                      @if (conversation.rating) {
                        <mat-icon class="rating-indicator" matTooltip="Rated {{ conversation.rating }}/5">star</mat-icon>
                      }
                      @if (conversationHasImages(conversation)) {
                        <ion-icon name="image-outline" class="image-indicator" matTooltip="Contains images"></ion-icon>
                      }
                      <button
                        mat-icon-button
                        class="action-button"
                        (click)="onStartRenameConversation(conversation, $event)"
                        matTooltip="Rename"
                        type="button">
                        <ion-icon name="pencil-outline"></ion-icon>
                      </button>
                      <button
                        mat-icon-button
                        class="action-button delete-button"
                        (click)="onDeleteConversation(conversation, $event)"
                        matTooltip="Delete"
                        type="button">
                        <ion-icon name="trash-outline"></ion-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      }

      <!-- Main Chat Area -->
      <div class="chat-container">
        <div class="chat-header">
          <button
            mat-icon-button
            (click)="toggleSidebar()"
            matTooltip="{{ showSidebar ? 'Hide historic chats' : 'Show historic chats' }}"
            type="button"
            class="history-toggle-button">
            <ion-icon name="time-outline"></ion-icon>
          </button>
          <button
            mat-icon-button
            (click)="onNewConversation()"
            matTooltip="New conversation"
            type="button"
            class="new-conversation-button">
            <ion-icon name="add-outline"></ion-icon>
          </button>
          <button
            mat-icon-button
            [matMenuTriggerFor]="optionsMenu"
            matTooltip="Options"
            type="button">
            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
          </button>
          <button
            mat-icon-button
            (click)="onClose()"
            matTooltip="Close Copilot"
            type="button"
            class="close-sidebar-button">
            <ion-icon name="close-outline"></ion-icon>
          </button>
          <mat-menu #optionsMenu>
            <button
              mat-menu-item
              (click)="onExportConversation()"
              [disabled]="messages.length === 0 || isExporting">
              <ion-icon name="download-outline"></ion-icon>
              <span>{{ isExporting ? 'Exporting...' : 'Export as Image' }}</span>
            </button>
            <button
              mat-menu-item
              (click)="onExportAllConversations()"
              [disabled]="conversations.length === 0">
              <ion-icon name="save-outline"></ion-icon>
              <span>Export All Conversations</span>
            </button>
            <button
              mat-menu-item
              (click)="onClearConversation()"
              [disabled]="messages.length === 0">
              <ion-icon name="refresh-outline"></ion-icon>
              <span>Clear Conversation</span>
            </button>
          </mat-menu>
        </div>

      @if (currentConversationScope) {
        <div class="scope-banner">
          <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          <div class="scope-banner-copy">
            <span class="scope-banner-title">{{ getCurrentScopeTitle() }}</span>
            <span class="scope-banner-context">{{ currentConversationScope.contextLabel }}</span>
          </div>
        </div>
      }

      <div class="provider-selector">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="provider-field">
          <mat-label>Provider</mat-label>
          <mat-select #providerSelect [(value)]="selectedProvider" [disabled]="providerLocked" (selectionChange)="onProviderChange()">
            @for (p of availableProviders; track p.value) {
              <mat-option [value]="p.value">{{ p.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="model-field">
          <mat-label>Model</mat-label>
          <mat-select #modelSelect [(ngModel)]="selectedModel" [disabled]="providerLocked" (selectionChange)="onModelChange()">
            @for (option of getAvailableModelOptions(); track option.id) {
              <mat-option [value]="option.id" [disabled]="option.status === 'legacy'">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="messages-container" #messagesContainer>
        @if (messages.length === 0) {
          <div class="welcome-message">
            <div class="welcome-icon">
              <img src="assets/device-illustrations/flask.svg" alt="Shake flask" class="flask-icon" />
            </div>
            <h3>Welcome to DOTS Copilot!</h3>
            <p>Ask me anything about bioprocessing, and I'll help you understand concepts, techniques, and best practices.</p>
            <p class="example-questions-label">Try asking:</p>
            <div class="example-questions">
              @for (question of exampleQuestions; track question) {
                <button
                  mat-stroked-button
                  class="example-question-chip"
                  (click)="onExampleQuestionClick(question)">
                  {{ question }}
                </button>
              }
            </div>
          </div>
        }
        @for (message of messages; track $index; let messageIndex = $index) {
          <div class="message" [class.user-message]="message.role === 'user'" [class.assistant-message]="message.role === 'assistant'">
            <div class="message-content">
              @if (message.role === 'user' && ($index === 0 || messages[$index - 1].role !== 'user')) {
                <div class="message-header">
                  <ion-icon name="person-outline"></ion-icon>
                  <span>You</span>
                </div>
              } @else if (message.role === 'assistant' && ($index === 0 || messages[$index - 1].role !== 'assistant')) {
                <div class="message-header">
                  <ion-icon name="chatbubble-outline"></ion-icon>
                  <span>Assistant</span>
                </div>
              }
              @if (getMessageImages(message).length > 0) {
                <div class="message-images">
                  @for (imageUrl of getMessageImages(message); track $index) {
                    <img
                      [src]="imageUrl"
                      alt="Uploaded image"
                      class="message-image clickable"
                      (click)="onImageClick(imageUrl)"
                      matTooltip="Click to enlarge" />
                  }
                </div>
              }
              @if (getMessageAttachmentIndicators(message).length > 0) {
                <div class="attachment-indicators">
                  @for (indicator of getMessageAttachmentIndicators(message); track indicator.kind) {
                    <span class="attachment-indicator-chip">
                      <ion-icon name="document-text-outline"></ion-icon>
                      <span>{{ indicator.label }}</span>
                    </span>
                  }
                </div>
              }
              @if (shouldShowMessageAnalysisIndicator(message)) {
                <div class="attachment-indicators">
                  <span class="attachment-indicator-chip analysis-indicator-chip">
                    <ion-icon [name]="getMessageAnalysisIndicatorIcon(message)"></ion-icon>
                    <span>{{ getMessageAnalysisIndicatorLabel(message) }}</span>
                  </span>
                </div>
              }
              @if (message.reasoning) {
                <div class="reasoning-container">
                  <button
                    class="reasoning-toggle"
                    (click)="toggleMessageReasoning($index)"
                    type="button">
                    <ion-icon [name]="isReasoningExpanded($index) ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
                    <span>Thought process</span>
                  </button>
                  @if (isReasoningExpanded($index)) {
                    <div class="reasoning-content">{{ message.reasoning }}</div>
                  }
                </div>
              }
              <div class="message-text-wrapper">
                <div
                  class="message-text"
                  [class.message-text-collapsed]="isMessageCollapsed(message, $index)"
                  [class.copilot-markdown]="message.role === 'assistant'"
                  [innerHTML]="formatMessage(message)"></div>
                <button
                  mat-icon-button
                  class="copy-button"
                  (click)="onCopyMessage(message)"
                  matTooltip="Copy message"
                  type="button">
                  <ion-icon name="copy-outline"></ion-icon>
                </button>
              </div>
              @if (shouldShowMessageToggle(message)) {
                <button
                  class="message-expand-toggle"
                  type="button"
                  [attr.aria-expanded]="isMessageExpanded($index)"
                  (click)="toggleMessageExpanded($index)">
                  {{ isMessageExpanded($index) ? 'Show less' : 'Show more' }}
                </button>
              }
              @if (getMessageActionProposals(message).length > 0) {
                <div class="action-proposals">
                  @for (proposal of getMessageActionProposals(message); track $index; let proposalIndex = $index) {
                    <div class="action-proposal-card">
                      <div class="action-proposal-header">
                        <span class="action-proposal-badge">{{ proposal.action }}</span>
                        <span class="action-proposal-title">{{ getActionProposalTitle(proposal) }}</span>
                      </div>
                      <div class="action-proposal-preview">{{ getActionProposalPreview(proposal) }}</div>
                      <div class="action-proposal-explanation">{{ proposal.explanation }}</div>
                      <div class="action-proposal-actions">
                        <button
                          mat-flat-button
                          color="primary"
                          type="button"
                          [disabled]="isActionProposalApplying(messageIndex, proposalIndex)"
                          (click)="onApplyActionProposal(messageIndex, proposalIndex)">
                          {{ isActionProposalApplying(messageIndex, proposalIndex) ? 'Applying...' : 'Apply' }}
                        </button>
                        <button
                          mat-stroked-button
                          type="button"
                          [disabled]="isActionProposalApplying(messageIndex, proposalIndex)"
                          (click)="onDismissActionProposal(messageIndex, proposalIndex)">
                          Dismiss
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (hasSetupTaskConfiguration(message)) {
                <div class="action-proposals">
                  <div class="action-proposal-card task-configuration-card">
                    <div class="action-proposal-header">
                      <span class="action-proposal-badge">task setup</span>
                      @if (getFocusedSetupTask(message); as focusedTask) {
                        <span class="action-proposal-title">{{ focusedTask.taskName }}</span>
                      }
                    </div>
                    <div class="action-proposal-preview">{{ getSetupTaskConfigurationProgressLabel(message) }}</div>
                    <div class="action-proposal-explanation">{{ getSetupTaskConfigurationDescription(message) }}</div>
                    @if (getSetupTaskConfigurationThingie(message); as contextThingie) {
                      @if (getSetupTaskConfigurationTask(message); as task) {
                        <div class="task-configuration-host">
                          <app-task-configuration
                            [task]="task"
                            [contextThingie]="contextThingie"
                            [processIdx]="getFocusedSetupTask(message)?.processIdx"
                            [taskIdx]="getFocusedSetupTask(message)?.taskIdx"
                            (taskChange)="onSetupTaskConfigurationTaskChange(messageIndex)">
                          </app-task-configuration>
                        </div>
                      }
                    }
                    <div class="action-proposal-actions">
                      <button
                        mat-stroked-button
                        type="button"
                        [disabled]="!canFocusPreviousSetupTask(message)"
                        (click)="onFocusPreviousSetupTask(messageIndex)">
                        Previous
                      </button>
                      <button
                        mat-stroked-button
                        type="button"
                        [disabled]="!canFocusNextSetupTask(message)"
                        (click)="onFocusNextSetupTask(messageIndex)">
                        Next
                      </button>
                      <button
                        mat-flat-button
                        color="primary"
                        type="button"
                        [disabled]="!canContinueSetupTaskConfiguration(message)"
                        (click)="onContinueSetupTaskConfiguration(messageIndex)">
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              }
              @if (getCsvAttachments(message).length > 0) {
                <div class="assistant-attachments">
                  @for (attachment of getCsvAttachments(message); track attachment.filename + '-' + $index) {
                    <div class="assistant-attachment-card">
                      <div class="assistant-attachment-header">
                        <div class="assistant-attachment-meta">
                          <div class="assistant-attachment-title-row">
                            <ion-icon name="document-text-outline"></ion-icon>
                            <span class="assistant-attachment-title">{{ attachment.filename }}</span>
                          </div>
                          <span class="assistant-attachment-subtitle">
                            {{ getCsvAttachmentSourceLabel(attachment) }} · {{ getCsvAttachmentSizeLabel(attachment) }}
                          </span>
                        </div>
                        <button
                          mat-stroked-button
                          type="button"
                          class="assistant-attachment-download"
                          (click)="onDownloadCsvAttachment(attachment)">
                          Download CSV
                        </button>
                      </div>
                      @if (getCsvAttachmentPreview(attachment).columns.length > 0) {
                        <div class="assistant-attachment-table-wrapper">
                          <table class="assistant-attachment-table">
                            <thead>
                              <tr>
                                @for (column of getCsvAttachmentPreview(attachment).columns; track column) {
                                  <th>{{ column }}</th>
                                }
                              </tr>
                            </thead>
                            <tbody>
                              @for (row of getCsvAttachmentPreview(attachment).rows; track $index) {
                                <tr>
                                  @for (cell of row; track $index) {
                                    <td>{{ cell }}</td>
                                  }
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      @if (getCsvAttachmentPreview(attachment).notice) {
                        <div class="assistant-attachment-notice">
                          {{ getCsvAttachmentPreview(attachment).notice }}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (message.role === 'assistant') {
                <div class="message-rating">
                  <button
                    mat-icon-button
                    class="thumb-button"
                    [class.active]="message.rating === 'up'"
                    (click)="onRateMessage($index, 'up')"
                    matTooltip="Helpful"
                    type="button">
                    <ion-icon [name]="message.rating === 'up' ? 'thumbs-up' : 'thumbs-up-outline'"></ion-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="thumb-button"
                    [class.active]="message.rating === 'down'"
                    (click)="onRateMessage($index, 'down')"
                    matTooltip="Not helpful"
                    type="button">
                    <ion-icon [name]="message.rating === 'down' ? 'thumbs-down' : 'thumbs-down-outline'"></ion-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
        @if (isStreaming) {
          <div class="message assistant-message streaming-message">
            <div class="message-content">
              <div class="message-header">
                <ion-icon name="chatbubble-outline"></ion-icon>
                <span>Assistant</span>
              </div>
              @if (currentStatus) {
                <div class="status-indicator">
                  <div class="status-spinner"></div>
                  <span>{{ currentStatus }}</span>
                </div>
              }
              @if (streamingReasoning) {
                <div class="reasoning-container streaming">
                  <button
                    class="reasoning-toggle"
                    (click)="toggleStreamingReasoning()"
                    type="button">
                    <ion-icon [name]="showReasoning ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
                    <span>Thinking...</span>
                  </button>
                  @if (showReasoning) {
                    <div class="reasoning-content" #streamingReasoningContent>{{ streamingReasoning }}<span class="streaming-cursor reasoning-cursor"></span></div>
                  }
                </div>
              }
              @if (streamingContent) {
                <div class="message-text-wrapper">
                  <div class="message-text streaming-text copilot-markdown" [innerHTML]="formatStreamingMessage(streamingContent)"></div>
                  <span class="streaming-cursor"></span>
                </div>
              } @else if (!streamingReasoning && !currentStatus) {
                <div class="thinking-container">
                  <div class="typing-indicator">
                    <span class="typing-dot"></span>
                    <span class="typing-dot"></span>
                    <span class="typing-dot"></span>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (showScrollToBottom) {
          <button
            mat-fab
            class="scroll-to-bottom-button"
            (click)="onScrollToBottom()"
            matTooltip="Scroll to bottom"
            type="button">
            <ion-icon name="chevron-down-outline"></ion-icon>
          </button>
        }
      </div>

      @if (showRatingPrompt && !isStreaming && !isLoading) {
        <div class="rating-section">
          <div class="rating-header">
            <span>How helpful was this conversation?</span>
            <button
              mat-icon-button
              class="rating-dismiss"
              (click)="onDismissRating()"
              matTooltip="Dismiss"
              type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
          </div>
          <div class="star-rating">
            @for (star of [1, 2, 3, 4, 5]; track star) {
              <button
                mat-icon-button
                class="star-button"
                [class.active]="conversationRating >= star"
                (click)="onSetConversationRating(star)"
                [matTooltip]="starLabels[star - 1]"
                type="button">
                <mat-icon>{{ conversationRating >= star ? 'star' : 'star_border' }}</mat-icon>
              </button>
            }
          </div>
          @if (conversationRating > 0) {
            <mat-form-field appearance="outline" class="feedback-field" subscriptSizing="dynamic">
              <mat-label>Any additional feedback? (optional)</mat-label>
              <textarea
                matInput
                [formControl]="feedbackInput"
                rows="2"
                [cdkTextareaAutosize]="true"
                [cdkAutosizeMinRows]="2"
                [cdkAutosizeMaxRows]="4"></textarea>
            </mat-form-field>
            <div class="rating-actions">
              <button
                mat-flat-button
                color="primary"
                (click)="onSubmitRating()"
                type="button">
                Submit Feedback
              </button>
            </div>
          }
        </div>
      }

      @if (error) {
        <div class="error-message">
          <mat-icon>error_outline</mat-icon>
          <span class="error-text">{{ error }}</span>
          <div class="error-actions">
            @if (lastErrorIndex !== null) {
              <button
                mat-button
                color="primary"
                (click)="onRetryMessage()"
                class="retry-button">
                Retry
              </button>
            }
            <button
              mat-icon-button
              (click)="onDismissError()"
              matTooltip="Dismiss"
              type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
          </div>
        </div>
      }

      <div class="input-container">
        @if (selectedLocalToolId) {
          <div class="attachment-indicators composer-attachment-indicators">
            <div class="attachment-indicator-chip tool-indicator-chip removable">
              <ion-icon name="flash-outline"></ion-icon>
              <span>{{ getSelectedLocalToolLabel() }}</span>
              <button
                mat-icon-button
                class="remove-attachment-button"
                (click)="onClearSelectedLocalTool()"
                matTooltip="Clear selected tool"
                type="button">
                <ion-icon name="close-circle-outline"></ion-icon>
              </button>
            </div>
          </div>
        }
        @if (pendingAttachmentIndicators.length > 0) {
          <div class="attachment-indicators composer-attachment-indicators">
            @for (indicator of pendingAttachmentIndicators; track indicator.kind) {
              <div class="attachment-indicator-chip removable">
                <ion-icon name="document-text-outline"></ion-icon>
                <span>{{ indicator.label }}</span>
                <button
                  mat-icon-button
                  class="remove-attachment-button"
                  (click)="onRemovePendingAttachmentIndicator(indicator.kind)"
                  matTooltip="Remove attachment"
                  type="button">
                  <ion-icon name="close-circle-outline"></ion-icon>
                </button>
              </div>
            }
          </div>
        }
        @if (shouldShowPendingAnalysisIndicator()) {
          <div class="attachment-indicators composer-attachment-indicators">
            <div class="attachment-indicator-chip analysis-indicator-chip">
              <ion-icon [name]="getPendingAnalysisIndicatorIcon()"></ion-icon>
              <span>{{ getPendingAnalysisIndicatorLabel() }}</span>
            </div>
          </div>
        }
        @if (selectedImages.length > 0) {
          <div class="selected-images-preview">
            @for (imageUrl of selectedImages; track $index) {
              <div class="image-preview-item">
                <img [src]="imageUrl" alt="Selected image" class="preview-image" />
                <button
                  mat-icon-button
                  class="remove-image-button"
                  (click)="onRemoveImage($index)"
                  matTooltip="Remove image"
                  type="button">
                  <ion-icon name="close-circle-outline"></ion-icon>
                </button>
              </div>
            }
          </div>
        }
        <mat-menu
          #toolGroupMenu="matMenu"
          class="tool-selector-menu"
          xPosition="after"
          yPosition="below"
          [overlapTrigger]="false"
          [hasBackdrop]="true">
          @for (group of localToolGroups; track group.id) {
            <button
              mat-menu-item
              class="tool-menu-item group-item"
              [matMenuTriggerFor]="group.id === 'experiment'
                ? experimentToolsMenu
                : group.id === 'graph'
                  ? graphToolsMenu
                  : group.id === 'data'
                    ? dataToolsMenu
                    : annotationToolsMenu"
              [disabled]="isToolGroupDisabled(group.id)">
              <ion-icon [name]="group.icon"></ion-icon>
              <div class="tool-menu-copy">
                <span>{{ group.label }}</span>
                <span class="tool-menu-description">{{ getToolGroupDescription(group.id) }}</span>
              </div>
              <ion-icon name="chevron-forward-outline" class="tool-menu-chevron"></ion-icon>
            </button>
          }
        </mat-menu>
        <mat-menu
          #experimentToolsMenu="matMenu"
          class="tool-selector-menu"
          xPosition="after"
          yPosition="below"
          [overlapTrigger]="false">
          @for (tool of getToolsForGroup('experiment'); track tool.id) {
            <button
              mat-menu-item
              class="tool-menu-item"
              (click)="onSelectLocalTool(tool.id)"
              [disabled]="!isLocalToolEnabled(tool.id)">
              <ion-icon [name]="tool.icon"></ion-icon>
              <div class="tool-menu-copy">
                <span>{{ tool.label }}</span>
                <span class="tool-menu-description">{{ isLocalToolEnabled(tool.id) ? tool.description : getLocalToolDisabledReason(tool.id) }}</span>
              </div>
              @if (isLocalToolSelected(tool.id)) {
                <ion-icon name="checkmark-outline" class="tool-menu-check"></ion-icon>
              }
            </button>
          }
        </mat-menu>
        <mat-menu
          #graphToolsMenu="matMenu"
          class="tool-selector-menu"
          xPosition="after"
          yPosition="below"
          [overlapTrigger]="false">
          @for (tool of getToolsForGroup('graph'); track tool.id) {
            <button
              mat-menu-item
              class="tool-menu-item"
              (click)="onSelectLocalTool(tool.id)"
              [disabled]="!isLocalToolEnabled(tool.id)">
              <ion-icon [name]="tool.icon"></ion-icon>
              <div class="tool-menu-copy">
                <span>{{ tool.label }}</span>
                <span class="tool-menu-description">{{ isLocalToolEnabled(tool.id) ? tool.description : getLocalToolDisabledReason(tool.id) }}</span>
              </div>
              @if (isLocalToolSelected(tool.id)) {
                <ion-icon name="checkmark-outline" class="tool-menu-check"></ion-icon>
              }
            </button>
          }
        </mat-menu>
        <mat-menu
          #dataToolsMenu="matMenu"
          class="tool-selector-menu"
          xPosition="after"
          yPosition="below"
          [overlapTrigger]="false">
          @for (tool of getToolsForGroup('data'); track tool.id) {
            <button
              mat-menu-item
              class="tool-menu-item"
              (click)="onSelectLocalTool(tool.id)"
              [disabled]="!isLocalToolEnabled(tool.id)">
              <ion-icon [name]="tool.icon"></ion-icon>
              <div class="tool-menu-copy">
                <span>{{ tool.label }}</span>
                <span class="tool-menu-description">{{ isLocalToolEnabled(tool.id) ? tool.description : getLocalToolDisabledReason(tool.id) }}</span>
              </div>
              @if (isLocalToolSelected(tool.id)) {
                <ion-icon name="checkmark-outline" class="tool-menu-check"></ion-icon>
              }
            </button>
          }
        </mat-menu>
        <mat-menu
          #annotationToolsMenu="matMenu"
          class="tool-selector-menu"
          xPosition="after"
          yPosition="below"
          [overlapTrigger]="false">
          @for (tool of getToolsForGroup('annotations'); track tool.id) {
            <button
              mat-menu-item
              class="tool-menu-item"
              (click)="onSelectLocalTool(tool.id)"
              [disabled]="!isLocalToolEnabled(tool.id)">
              <ion-icon [name]="tool.icon"></ion-icon>
              <div class="tool-menu-copy">
                <span>{{ tool.label }}</span>
                <span class="tool-menu-description">{{ isLocalToolEnabled(tool.id) ? tool.description : getLocalToolDisabledReason(tool.id) }}</span>
              </div>
              @if (isLocalToolSelected(tool.id)) {
                <ion-icon name="checkmark-outline" class="tool-menu-check"></ion-icon>
              }
            </button>
          }
        </mat-menu>
        <div class="input-row">
          <input
            #imageInput
            type="file"
            accept="image/*"
            multiple
            (change)="onImageSelected($event)"
            class="hidden-file-input"
            id="image-input" />
          <button
            mat-icon-button
            type="button"
            (click)="imageInput.click()"
            matTooltip="Add image"
            class="image-button">
            <mat-icon>attach_file</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            [matMenuTriggerFor]="toolGroupMenu"
            matTooltip="Open tools"
            class="tool-button">
            <mat-icon>add</mat-icon>
          </button>
          <mat-form-field appearance="outline" class="message-input" subscriptSizing="dynamic">
            <textarea
              matInput
              placeholder="Type your message..."
              [formControl]="messageInput"
              (keydown)="onKeyDown($event)"
              rows="1"
              [cdkTextareaAutosize]="true"
              [cdkAutosizeMinRows]="1"
              [cdkAutosizeMaxRows]="4"></textarea>
          </mat-form-field>
          <button
            mat-icon-button
            color="primary"
            (click)="onSendMessage()"
            [disabled]="(!messageInput.value?.trim() && selectedImages.length === 0 && pendingAttachmentIndicators.length === 0 && !selectedLocalToolId)
              || !canSendWithSelectedTool(messageInput.value?.trim() || '')
              || isLoading"
            class="send-button"
            matTooltip="Send message"
            type="button">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Image Lightbox -->
  @if (lightboxImage) {
    <div class="image-lightbox" (click)="onCloseLightbox()">
      <button
        mat-icon-button
        class="lightbox-close"
        aria-label="Close"
        type="button">
        <ion-icon name="close-outline"></ion-icon>
      </button>
      <img
        [src]="lightboxImage"
        alt="Full size image"
        (click)="$event.stopPropagation()" />
    </div>
  }
</div>
